import React from "react";
import { Bar } from "react-chartjs-2";

import {
	BarElement,
	CategoryScale,
	Chart as ChartJS,
	Legend,
	LinearScale,
	Title,
	Tooltip,
} from "chart.js";

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
);

const WaterfallChart = ({ updates }) => {
	// Prepare data for the waterfall chart
	const labels = updates.map((update, index) => `Update ${index + 1}`);

	// Calculate the duration in seconds or minutes (based on your need)
	const durations = updates.map((update, index) => {
		if (index === 0) return 0;
		const start = new Date(updates[index - 1].Date);
		const end = new Date(update.Date);
		const durationInSeconds = (end - start) / 1000; // Convert to seconds
		return durationInSeconds;
	});

	// Prepare cumulative data
	let cumulative = 0;
	const cumulativeData = durations.map((duration) => {
		cumulative += duration;
		return cumulative;
	});

	// Prepare chart data
	const data = {
		labels: labels,
		datasets: [
			{
				label: "Update Duration (s)",
				data: durations,
				backgroundColor: "rgba(75, 192, 192, 0.6)",
				stack: "Stack 0",
			},
			{
				label: "Cumulative Duration (s)",
				data: cumulativeData,
				backgroundColor: "rgba(153, 102, 255, 0.6)",
				stack: "Stack 1",
			},
		],
	};

	const options = {
		scales: {
			x: {
				stacked: true,
			},
			y: {
				stacked: true,
				title: {
					display: true,
					text: "Duration (s)",
				},
			},
		},
		plugins: {
			title: {
				display: true,
				text: "Waterfall Chart of Update Durations",
			},
			tooltip: {
				callbacks: {
					label: function (tooltipItem) {
						return ` ${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}s`;
					},
				},
			},
		},
	};

	return <Bar data={data} options={options} />;
};

export default WaterfallChart;
